<template>
  <b-card v-if="this.table.data" header-bg-variant="custom" no-body>
      <template #header>
      <h4 v-html="title" class="text-white" />
    </template>
    <b-row>
        <b-col class="col-12" v-if="period_info">
          <p class="text-muted text-sm">{{ period_info }}</p>
        </b-col>
      <b-col sm="12">
        <div id="table_container"></div>
      </b-col>
    </b-row>
  </b-card>
</template>

<script>
export default {
  props: {
    table: { type: Object, required: true },
    title: { type: String, required: true },
    period_info: { type: String, defaul: null },
  },
  mounted() {
    this.buildTable();
  },
  methods: {
    buildTable() {
      let tableHtml = "<table class='table table-stripped'>";

      // table header
      tableHtml += "<thead>";
      tableHtml += "<tr>";
      this.table.header.forEach(function (header) {
        tableHtml += "<th>" + header + "</th>";
      });
      tableHtml += "</tr>";
      tableHtml += "</thead>";

      // table content
      tableHtml += "<tbody>";

      // variables for loop
      let category_id = 0;
      let sub_overnights = 0;
      let sub_arrivals = 0;
      let sub_overnights_prev = 0;
      let sub_marketShare = 0;
      let sub_foreignShare = 0;

      let tot_main_overnights = 0;
      let tot_main_arrivals = 0;
      let tot_main_overnights_prev = 0;
      let tot_main_marketShare = 0;
      let tot_main_foreignShare = 0;

      let tot_overnights = 0;
      let tot_arrivals = 0;
      let tot_overnights_prev = 0;
      let tot_marketShare = 0;
      let tot_foreignShare = 0;

      let cpt = 0;

      this.table.data.forEach((row) => {
        // check if a new category needs to be create
        if (category_id != row.category) {
          // add subtotal lines
          if (category_id != 0) {
            // compute evolutions
            var sub_evolutionReal = sub_overnights - sub_overnights_prev;
            var sub_evolutionPerc = sub_overnights / sub_overnights_prev - 1;
            var sub_durationStay = sub_overnights / sub_arrivals;

            // Add total without Übrige Länder
            var tot_main_evolutionReal = tot_main_overnights - tot_main_overnights_prev;
            var tot_main_evolutionPerc = tot_main_overnights / tot_main_overnights_prev - 1;
            var tot_main_durationStay = tot_main_overnights / tot_main_arrivals;

            tableHtml += "<tr class='subotal'>";
            tableHtml +=
              "<td>" +
              (this.$i18n.locale == "de" ? "Subtotal" : "Sous-total") +
              "</td>";
            tableHtml += "<td>" + sub_arrivals.toLocaleString("de-CH") + "</td>";
            tableHtml += "<td>" + sub_overnights.toLocaleString("de-CH") + "</td>";
            tableHtml += "<td>" + sub_evolutionPerc.
                toLocaleString("de-CH", { style:'percent', maximumFractionDigits: 2}) + "</td>";
            tableHtml += "<td>" + sub_evolutionReal.toLocaleString("de-CH") + "</td>";
            tableHtml += "<td>" + sub_marketShare.
                toLocaleString("de-CH", { style:'percent', maximumFractionDigits: 2}) + "</td>";
            tableHtml += "<td>" + sub_foreignShare.
                toLocaleString("de-CH", { style:'percent', maximumFractionDigits: 2}) + "</td>";
            tableHtml += "<td>" + sub_durationStay.toLocaleString("de-CH", { maximumFractionDigits: 2}) + "</td>";
            
            cpt++

            if(cpt == 5){
              tableHtml += "<tr class='total'>";
              tableHtml += "<td>Total Hauptmärkte</td>";
              tableHtml += "<td>" + tot_main_arrivals.toLocaleString("de-CH") + "</td>";
              tableHtml += "<td>" + tot_main_overnights .toLocaleString("de-CH")+ "</td>";
              tableHtml += "<td>" + tot_main_evolutionPerc.toLocaleString("de-CH", {
              style: "percent",
              maximumFractionDigits: 2,
                }) + "</td>";
              tableHtml += "<td>" + tot_main_evolutionReal.toLocaleString("de-CH") + "</td>";
              tableHtml += "<td>" + tot_main_marketShare.toLocaleString("de-CH", {
              style: "percent",
              maximumFractionDigits: 2,
          }) + "</td>";
              tableHtml += "<td>" + tot_main_foreignShare.toLocaleString("de-CH", {
              style: "percent",
              maximumFractionDigits: 2,
          }) + "</td>";
            tableHtml += "<td>" + tot_main_durationStay.toLocaleString("de-CH", {
            maximumFractionDigits: 2,
          }) + "</td>";

            }

            // reset variables
            sub_overnights = 0;
            sub_arrivals = 0;
            sub_overnights_prev = 0;
            sub_marketShare = 0;
            sub_foreignShare = 0;
          }

          tableHtml += "<tr>";
          tableHtml +=
            "<td class='classif_header' colspan='8'>" +
            row.categoryName +
            "</td>";
          tableHtml += "</tr>";

          // reset variables
          category_id = row.category;
          sub_overnights = 0;
          sub_arrivals = 0;
          sub_overnights_prev = 0;
          sub_marketShare = 0;
          sub_foreignShare = 0;
        }

        // add new row
        var marketNights = row.overnighsAct;
        var marketNightsBef = row.overnighsBef;
        var arrivals = row.arrivals;
        var evoReal = marketNights - marketNightsBef;
        var evoPercent = marketNights / marketNightsBef - 1;
        var marketShare = row.marketShare;
        var foreignShare = row.country == "Schweiz" ? -1 : row.foreignShare;
        var stayDuration = marketNights / arrivals;

        // add to totals
        sub_overnights += marketNights;
        sub_arrivals += arrivals;
        sub_overnights_prev += marketNightsBef;
        sub_marketShare += marketShare;
        sub_foreignShare += foreignShare;


        tot_overnights += marketNights;
        tot_arrivals += arrivals;
        tot_overnights_prev += marketNightsBef;
        tot_marketShare += marketShare;
        tot_foreignShare += row.country == "Schweiz" ? 0 : foreignShare;

        switch(row.category) {
          case 1: 
            tot_main_overnights += marketNights;
            tot_main_arrivals += arrivals;
            tot_main_overnights_prev += marketNightsBef;
            tot_main_marketShare += marketShare;
            tot_main_foreignShare += row.country == "Schweiz" ? 0 : foreignShare;
            break;
           case 2: 
            tot_main_overnights += marketNights;
            tot_main_arrivals += arrivals;
            tot_main_overnights_prev += marketNightsBef;
            tot_main_marketShare += marketShare;
            tot_main_foreignShare += row.country == "Schweiz" ? 0 : foreignShare;
            break;
           case 3: 
            tot_main_overnights += marketNights;
            tot_main_arrivals += arrivals;
            tot_main_overnights_prev += marketNightsBef;
            tot_main_marketShare += marketShare;
            tot_main_foreignShare += row.country == "Schweiz" ? 0 : foreignShare;
            break;
           case 4:
            tot_main_overnights += marketNights;
            tot_main_arrivals += arrivals;
            tot_main_overnights_prev += marketNightsBef;
            tot_main_marketShare += marketShare;
            tot_main_foreignShare += row.country == "Schweiz" ? 0 : foreignShare;
            break;
           case 9:
            tot_main_overnights += marketNights;
            tot_main_arrivals += arrivals;
            tot_main_overnights_prev += marketNightsBef;
            tot_main_marketShare += marketShare;
            tot_main_foreignShare += row.country == "Schweiz" ? 0 : foreignShare;
            break;
        }

        
        tableHtml += "<tr class='sub"+row.category+"'>";
        tableHtml += "<td>" + row.country + "</td>";
        tableHtml += "<td>" + arrivals.toLocaleString("de-CH") + "</td>";
        tableHtml += "<td>" + marketNights.toLocaleString("de-CH") + "</td>";
        tableHtml +=
          "<td>" +
          evoPercent.toLocaleString("de-CH", {
            style: "percent",
            maximumFractionDigits: 2,
          }) +
          "</td>";
        tableHtml += "<td>" + evoReal.toLocaleString("de-CH") + "</td>";
        tableHtml += "<td>" + marketShare.toLocaleString("de-CH", {
            style: "percent",
            maximumFractionDigits: 2,
          }) + "</td>";
        tableHtml += "<td>" + (foreignShare >= 0 ? foreignShare.toLocaleString("de-CH", {
            style: "percent",
            maximumFractionDigits: 2,
          }) : "") + "</td>";
        tableHtml += "<td>" + stayDuration.toLocaleString("de-CH", {
            maximumFractionDigits: 2,
          }) + "</td>";
      });

      // Add subtotal for last category
      // compute evolutions
      var sub_evolutionReal = sub_overnights - sub_overnights_prev;
      var sub_evolutionPerc = sub_overnights / sub_overnights_prev - 1;
      var sub_durationStay = sub_overnights / sub_arrivals;

      tableHtml += "<tr class='subotal'>";
      tableHtml +=
        "<td>" + (this.$i18n.locale == "de" ? "Subtotal" : "Sous-total") + "</td>";
      tableHtml += "<td>" + sub_arrivals.toLocaleString("de-CH") + "</td>";
      tableHtml += "<td>" + sub_overnights.toLocaleString("de-CH") + "</td>";
      tableHtml += "<td>" + sub_evolutionPerc.toLocaleString("de-CH", {
            style: "percent",
            maximumFractionDigits: 2,
          }) + "</td>";
      tableHtml += "<td>" + sub_evolutionReal.toLocaleString("de-CH") + "</td>";
      tableHtml += "<td>" + sub_marketShare.toLocaleString("de-CH", {
            style: "percent",
            maximumFractionDigits: 2,
          }) + "</td>";
      tableHtml += "<td>" + sub_foreignShare.toLocaleString("de-CH", {
            style: "percent",
            maximumFractionDigits: 2,
          }) + "</td>";
      tableHtml += "<td>" + sub_durationStay.toLocaleString("de-CH", {
            maximumFractionDigits: 2,
          }) + "</td>";

      // add total for last category
      // Add subtotal for last category
      var tot_evolutionReal = tot_overnights - tot_overnights_prev;
      var tot_evolutionPerc = tot_overnights / tot_overnights_prev - 1;
      var tot_durationStay = tot_overnights / tot_arrivals;
      tableHtml += "<tr class='total'>";
      tableHtml += "<td>TOTAL</td>";
      tableHtml += "<td>" + tot_arrivals.toLocaleString("de-CH") + "</td>";
      tableHtml += "<td>" + tot_overnights .toLocaleString("de-CH")+ "</td>";
      tableHtml += "<td>" + tot_evolutionPerc.toLocaleString("de-CH", {
            style: "percent",
            maximumFractionDigits: 2,
          }) + "</td>";
      tableHtml += "<td>" + tot_evolutionReal.toLocaleString("de-CH") + "</td>";
      tableHtml += "<td>" + tot_marketShare.toLocaleString("de-CH", {
            style: "percent",
            maximumFractionDigits: 2,
          }) + "</td>";
      tableHtml += "<td>" + tot_foreignShare.toLocaleString("de-CH", {
            style: "percent",
            maximumFractionDigits: 2,
          }) + "</td>";
      tableHtml += "<td>" + tot_durationStay.toLocaleString("de-CH", {
            maximumFractionDigits: 2,
          }) + "</td>";

      tableHtml += "</tbody>";
      tableHtml += "</table>";

      document.getElementById("table_container").innerHTML = tableHtml;
    },
  },
};
</script>

<style>
td.classif_header {
  font-size: 1.2em;
  font-weight: bold;
  background: rgba(52, 152, 219, 0.3);
}
tr.subotal {
  font-size: 1.1em;
  font-weight: bold;
}
tr.total {
  font-size: 1.2em;
  font-weight: bold;
  background: rgba(52, 152, 219, 0.8);
}
.small {
  font-size: 0.8em;
}

.text-sm {
  font-size: 0.8rem;
}
</style>